import {
  Anchor,
  Archive,
  Bell,
  BookOpen,
  Boxes,
  Building2,
  Calendar,
  CalendarDays,
  ChartColumn,
  ChartLine,
  CircleCheck,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cog,
  Container,
  Database,
  Droplets,
  Euro,
  Factory,
  FileSpreadsheet,
  FileText,
  FolderOpen,
  Fuel,
  Gauge,
  Hammer,
  HardHat,
  House,
  Key,
  LayoutDashboard,
  Leaf,
  LifeBuoy,
  ListChecks,
  Lock,
  Mail,
  MapPin,
  NotebookPen,
  Package,
  PenTool,
  Phone,
  Printer,
  QrCode,
  Recycle,
  Ruler,
  Scale,
  Server,
  Settings,
  Shield,
  Ship,
  SlidersHorizontal,
  SquareStack,
  Sprout,
  Timer,
  TrendingUp,
  TriangleAlert,
  Truck,
  UserCheck,
  Users,
  Wallet,
  Warehouse,
  Wind,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

/**
 * Die Icons, die ein Modul in seiner `module.config.ts` verwenden darf.
 *
 * Warum eine feste Liste statt „irgendein lucide-Icon": ein dynamischer Zugriff
 * auf die gesamte Bibliothek zieht mehrere tausend Icons ins Bundle. Reicht die
 * Auswahl nicht, ergänzt der Plattform-Owner diese Datei — das ist ein
 * Einzeiler.
 */
export const moduleIcons = {
  Anchor,
  Archive,
  Bell,
  BookOpen,
  Boxes,
  Building2,
  Calendar,
  CalendarDays,
  ChartColumn,
  ChartLine,
  CircleCheck,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cog,
  Container,
  Database,
  Droplets,
  Euro,
  Factory,
  FileSpreadsheet,
  FileText,
  FolderOpen,
  Fuel,
  Gauge,
  Hammer,
  HardHat,
  House,
  Key,
  LayoutDashboard,
  Leaf,
  LifeBuoy,
  ListChecks,
  Lock,
  Mail,
  MapPin,
  NotebookPen,
  Package,
  PenTool,
  Phone,
  Printer,
  QrCode,
  Recycle,
  Ruler,
  Scale,
  Server,
  Settings,
  Shield,
  Ship,
  SlidersHorizontal,
  SquareStack,
  Sprout,
  Timer,
  TrendingUp,
  TriangleAlert,
  Truck,
  UserCheck,
  Users,
  Wallet,
  Warehouse,
  Wind,
  Wrench,
  Zap,
} satisfies Record<string, LucideIcon>

export type ModuleIconName = keyof typeof moduleIcons

/** Alle erlaubten Icon-Namen, alphabetisch — für Fehlermeldungen und Doku. */
export const moduleIconNames = Object.keys(moduleIcons).sort() as ModuleIconName[]

export interface ModuleIconProps {
  /** Name aus {@link moduleIcons}, z.B. 'Wrench'. */
  name: string
  className?: string
}

/**
 * Zeigt das Icon eines Moduls anhand seines Namens aus dem Manifest.
 * Ist der Name unbekannt, erscheint ein Ersatzicon und im Log steht, welche
 * Namen erlaubt sind.
 *
 * @example
 * ```tsx
 * <ModuleIcon name={modul.icon} className="size-5" />
 * ```
 */
export function ModuleIcon({ name, className }: ModuleIconProps) {
  const Icon = moduleIcons[name as ModuleIconName]

  if (!Icon) {
    console.warn(
      `[berky] Das Icon "${name}" gibt es nicht. Erlaubt sind: ${moduleIconNames.join(', ')}`,
    )
    return <Package className={className} aria-hidden="true" />
  }

  return <Icon className={className} aria-hidden="true" />
}
